export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70ddabb6f7f9d1dcffb72666c96059b6ed6e5a8cca&name=pushAdClickData!'